import { SalesByValueReportItem } from '../../../types/salesByValueReportItem'
import { GraphValueType } from '../enums/graphValueType'
import { SalesReportFormattedGraphData } from '../types/salesReportFormattedGraphData'
import { SalesReportGraphSummary } from '../types/salesReportGraphSummary'
import { getEmptyGraphValues } from './getEmptyGraphValues'
import { getFormattedGraphTemplateValues } from './getFormattedGraphTemplateValues'

const TOP_ITEMS_COUNT = 5

interface FormattedGraphDataByValue {
  graphData: SalesReportFormattedGraphData[]
  graphSummary?: SalesReportGraphSummary
}

interface FormatGraphDataByValueProps {
  salesReport: SalesByValueReportItem[]
}

const getSalesReportItemId = (item: SalesByValueReportItem) => ('customerId' in item ? item.customerId : item.productId)

export const formatGraphDataByValue = ({ salesReport }: FormatGraphDataByValueProps): FormattedGraphDataByValue => {
  if (!salesReport) {
    return { graphData: [] }
  }

  const graphTemplateValues = getFormattedGraphTemplateValues(salesReport, TOP_ITEMS_COUNT)

  const graphData = graphTemplateValues.map((template) => {
    // Get all sales report items corresponding to this graph template by ID
    const relatedReports = salesReport.filter((item) => getSalesReportItemId(item) === template.id)

    const values = relatedReports.reduce((valueResult, item) => {
      if (item?.summary?.paid) {
        valueResult[GraphValueType.Gross].paid += item.summary.paid.grossTotal
        valueResult[GraphValueType.Net].paid += item.summary.paid.netTotal
      }

      if (item?.summary?.open) {
        valueResult[GraphValueType.Gross].unpaid += item.summary.open.grossTotal
        valueResult[GraphValueType.Net].unpaid += item.summary.open.netTotal
      }

      return valueResult
    }, getEmptyGraphValues())

    return { ...template, values }
  })

  const graphSummary = graphData.reduce((summaryResult, month) => {
    summaryResult[GraphValueType.Gross].paid += month.values.gross.paid
    summaryResult[GraphValueType.Gross].unpaid += month.values.gross.unpaid
    summaryResult[GraphValueType.Gross].total += month.values.gross.paid + month.values.gross.unpaid

    summaryResult[GraphValueType.Net].paid += month.values.net.paid
    summaryResult[GraphValueType.Net].unpaid += month.values.net.unpaid
    summaryResult[GraphValueType.Net].total += month.values.net.paid + month.values.net.unpaid

    return summaryResult
  }, getEmptyGraphValues())

  const slicedReport = graphData.slice(0, TOP_ITEMS_COUNT)

  return {
    graphData: slicedReport,
    graphSummary: { ...graphSummary, totalAmount: salesReport.length },
  }
}
